import { Location, PlatformLocation } from '@angular/common';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MobileAppService {
  private readonly platformLocation = inject(PlatformLocation);
  private readonly location = inject(Location);

  public readonly isMobileApp = signal<boolean>(false);

  private readonly mobileParamRegex = new RegExp(`${environment.core.mobileAppQueryParam}=?.*`);

  constructor() {
    this.location.onUrlChange((url, _state) => {
      const [_path, query] = url.split('?');
      const params = query?.split('&') ?? [];

      // We consider that the website is open in one of the mobile apps webview
      // if the hostname corresponds to the one used only by the mobile apps
      // or if the mobile app query param is present
      if (
        this.platformLocation.hostname === environment.core.mobileAppHostname ||
        params.some((q) => this.mobileParamRegex.test(q))
      ) {
        this.isMobileApp.set(true);
      } else {
        this.isMobileApp.set(false);
      }
    });
  }
}
